import useSWRMutation from "swr/mutation";
import { API_REST_METHODS } from "../../../common/constants";
import { fetcher } from "../../../common/hooks";

export interface SpaceRequestBody {
    page?: number;
    pageSize?: number;
    hasDevices?: boolean | null;
    sortType?: string;
    sortAsc?: boolean;
    spaceId?: string | null;
    subSpaceId?: string | null;
}

export const usePostSpaceRequest = ({
    companyId,
    locationId,
    onSuccess,
    onError,
}: {
    companyId?: string;
    locationId?: string;
    onSuccess?: () => void;
    onError?: (err: any, key: string) => void;
}) => {
    const { trigger: triggerPostSpaceRequest, isMutating: isLoadingPostSpaceRequest } =
        useSWRMutation(
            companyId && locationId
                ? `/api/device-management/v1/companies/${companyId}/locations/${locationId}/space-request`
                : null,
            (url: string, { arg }: { arg: SpaceRequestBody }) =>
                fetcher(url, {
                    options: {
                        method: API_REST_METHODS.POST,
                        body: JSON.stringify(arg),
                    },
                }),
            { onSuccess, onError }
        );

    return { triggerPostSpaceRequest, isLoadingPostSpaceRequest };
};
